import React from 'react'
import SessionType from '../../models/Session'
import Card from '../Card'
import Text from '../Text'
import Button from '../Button'
import { useRequest } from '@polvo-labs/react-auth'
import DescriptionList from '../DescriptionList'

interface Props {
  session: SessionType
  onLoggedOut: () => void
}

const Realty: React.FC<Props> = ({ session, onLoggedOut }) => {
  const { request } = useRequest()

  return (
    <Card>
      <Text
        tag="h2"
        color="darkBlue"
      >
        {session.current_session ?
          'Sessão atual' :
          `${
            new Date(session.created_at).toLocaleDateString()
          } às ${
            new Date(session.created_at).toLocaleTimeString()
          }`
        }
      </Text>

      <DescriptionList
        items={[{
          term: 'Local',
          description: session.location,
        }, {
          term: 'Dispositivo',
          description: session.device,
        }]}
      />

      {!session.current_session && (
        <Button
          label="Sair dessa sessão"
          backgroundColor="transparent"
          fontColor="red"
          borderColor="lightGray"
          block
          onClick={() => {
            request({
              method: 'DELETE',
              url: `${process.env.REACT_APP_API_URL}/sessions/${session.id}`,
            }).then(() => {
              onLoggedOut()
            })
          }}
        />
      )}
    </Card>
  )
}

export default Realty
